(function() {
    'use strict';

    angular.module('stats')
        .directive('cpPackagesStats', cpPackagesStats);

    cpPackagesStats.$inject = ['$state', 'packagesStatsDataSrvc', 'clientStatsDataSrvc', 'dateFormatConst', 'momentSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc', 'previewStatsSrvc'];

    function cpPackagesStats($state, packagesStatsDataSrvc, clientStatsDataSrvc, dateFormatConst, momentSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc, previewStatsSrvc) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/stats/directives/packages-stats/packages-stats.html',
            scope: {
                isDefault: '=',
                weeks: '=',
                months: '=',
                years: '=',
                shopVersion: '='
            },
            link: function(scope, element, attrs, controller) {
                var self = scope;
                self.loading = true;

                self.dateRange = {daterangeFilter: {startDate: null, endDate: null}}
                self.shopVersionOptions = [];
                self.response = [];
                self.stats = [{
                    title: 'Ilość przesyłek - system',
                    value: 'no_system',
                }, {
                    title: 'Ilość przesyłek - UPS',
                    value: 'no_ups',
                }, {
                    title: 'Waga przesyłek - system',
                    value: 'weight_system',
                }, {
                    title: 'Waga przesyłek - pakowanie',
                    value: 'weight_packed',
                }, {
                    title: 'Koszt wysyłki - system',
                    value: 'price_system',
                }, {
                    title: 'Koszt wysyłki - UPS',
                    value: 'price_ups',
                }, {
                    title: 'Przesyłek pobraniowych',
                    value: 'delivery_packages',
                }, {
                    title: 'Koszt przesyłek pobraniowych',
                    value: 'price_delivery_packages',
                }, {
                    title: 'Przesyłki poszczególne dni',
                    value: 'days',
                    details: true,
                    detailsOnClick: previewStatsSrvc.previewPackageDays,
                }, {
                    title: 'Zamówienia zagraniczne z UE',
                    value: 'orders_eu',
                }, {
                    title: 'Zamówienia zagraniczne z poza UE',
                    value: 'orders_not_ue',
                }, {
                    title: 'Wartość przesyłek zagranicznych - system',
                    value: 'price_foreign_system',
                }, {
                    title: 'Wartość przesyłek zagranicznych - ups',
                    value: 'price_foreign_ups',
                }, {
                    title: 'Zamówień wieloadresowych',
                    value: 'orders_multiaddress',
                }, {
                    title: 'Zamówień z podzielonym nakładem',
                    value: 'orders_cut',
                }, {
                    title: 'Wartość doliczonych kosztów związanych z podziałem zamówienia',
                    value: 'price_orders_cut',
                }];

                self.getStatValue = function(stat) {
                    return self.response[stat]
                }

                self.showDetails = function(statVal) {
                    console.log('jestem', statVal)
                }

                self.searchQuery = {
                    pk: null,
                    name: null,
                    ordering: null
                };

                self.dateFormat = dateFormatConst.defaultPythonDate;
                self.filterData = {
                    min_date: null,
                    max_date: null,
                    shop_version: null
                };

                self.pageChange = pageChange;
                self.onSearchQueryChange = onSearchQueryChange;
                self.changeFilter = changeFilter;

                activate();

                function activate() {
                    self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
                    getShopVersions();
                    filterQuerySrvc.setLocationParams();
                    var minDate = moment(self.filterData.min_date, 'DD.MM.YYYY');
                    var maxDate = moment(self.filterData.max_date, 'DD.MM.YYYY');
                    if (!scope.isDefault){
                        if (scope.weeks) {
                            minDate = minDate.subtract(scope.weeks, 'w')
                            maxDate = maxDate.subtract(scope.weeks, 'w')
                        }
                        if (scope.months) {
                            minDate = minDate.subtract(scope.months, 'M')
                            maxDate = maxDate.subtract(scope.months, 'M')
                        }
                        if (scope.years) {
                            minDate = minDate.subtract(scope.years, 'y')
                            maxDate = maxDate.subtract(scope.years, 'y')
                        }
                        self.filterData.min_date = minDate.format(dateFormatConst.backendDate);
                        self.filterData.max_date = maxDate.format(dateFormatConst.backendDate);;
                    }

                    if (self.filterData.min_date) {
                        self.dateRange.daterangeFilter['startDate'] = minDate;
                        self.dateRange.daterangeFilter['endDate'] = maxDate;
                    }
                    getStats();
                }

                function getShopVersions() {
                    clientStatsDataSrvc.shopVersions().$promise.then(
                        function(response) {
                            self.shopVersionOptions = response;
                        }
                    )
                }

                function getStats(filterObj) {
                    self.loading = true;

                    if (!filterObj) {
                        filterObj = {
                            min_date: self.filterData.min_date || null,
                            max_date: self.filterData.max_date || null,
                            shop_version: self.filterData.shop_version || null
                        }
                    }
                    packagesStatsDataSrvc.stats(filterObj)
                        .$promise
                        .then(
                            function (response) {
                                self.response = response;
                            },
                            function (response) {
                                if (response.status === 404 && filterObj.page !== 1) {
                                    checkSearchSrvc.recall(filterObj, getStats);
                                }
                            }
                        )
                        .finally(
                            function(response) {
                                self.loading = false;
                                return response;
                            }
                        );
                }

                function pageChange() {
                    filterQuerySrvc.updatePageOpts(self.pageOpts);
                    filterQuerySrvc.setLocationParams();
                    getStats();
                }

                function onSearchQueryChange() {
                    filterQuerySrvc.updateSearchQuery(self.searchQuery);
                    filterQuerySrvc.setLocationParams();
                    getStats();
                }

                function changeFilter() {
                    if (self.dateRange.daterangeFilter.startDate) {
                        self.filterData.min_date = self.dateRange.daterangeFilter.startDate.format(dateFormatConst.backendDate);
                        self.filterData.max_date = self.dateRange.daterangeFilter.endDate.format(dateFormatConst.backendDate)
                    } else {
                        self.filterData.min_date = null;
                        self.filterData.max_date = null;
                    }
                    if (scope.isDefault) {
                        filterQuerySrvc.updateFilterData(self.filterData);
                        filterQuerySrvc.setLocationParams();
                    }
                    getStats();
                }
            }
        };
    }
})();
